import React from 'react';
import DefaultRoutes from '../../routing/defaultRoutes/DefaultRoutes';
import { ContentTypes } from '../../core/constants/contentTypes';

function GameRules() {
  return (
    <div className='cpt-pp-content for-test-info'>
      <div className='cpt-content-wrp'>
        <DefaultRoutes contentType={ContentTypes.GameRulesContent} />
      </div>
    </div>
  );
}

export default GameRules;
